// +----------------------------------------------------------------------
// | Desc: 全局config配置信息库
// +----------------------------------------------------------------------
const config = {
    api: "https://server.xunji666.com", //api基础路由
    img: "https://server.xunji666.com", //img连接基础路由
    serverH5: "https://manageh5.xunji666.com", //服务端前端路由
    qiyebigscreenH5: "https://qiye.xunji666.com", //企业大屏路由
}
export default config